import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveIPV4Component } from '../../shared/components/SaveIPV4Component';

export interface CreateIPV4PageProps {}

const CreateIPV4Page: React.FC<CreateIPV4PageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_ipv4);

  return <SaveIPV4Component title="Crear IPV4" />;
};

export default CreateIPV4Page;
